import React, { useCallback, useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';

import TagFilters from 'components/vehicleFilters/TagFilters';
import Select from 'components/bronson/Select';
import Traductor from 'components/Traductor';

const HeaderPageFilters = ({
    filters,
    filtersOptions,
    initialFilters,
    setFilters,
    resetFilters,
    renderFilters,
    extraContent,
    orderFilters,
}) => {
    const t = useMemo(() => new Traductor(), []);
    const isMobileOrTablet = useMediaQuery({ maxWidth: 960 });

    const changeOrderVehicleList = useCallback(
        orderId => {
            if (orderId >= 0) {
                const order = filters.Orders.find(o => o.SelectId === +orderId);
                if (order) {
                    order.Page = initialFilters.initPage;
                    order.Count = initialFilters.initCountVehicles;
                }
                setFilters({ ...filters, filterOrder: order });
            } else {
                setFilters({
                    ...filters,
                    filterOrder: {
                        SelectId: '',
                        FieldName: '',
                        OrderType: '',
                        Page: initialFilters.initPage,
                        Count: initialFilters.initCountVehicles,
                    },
                });
            }
        },
        [
            filters,
            initialFilters.initCountVehicles,
            initialFilters.initPage,
            setFilters,
        ]
    );

    const printOrderFilter = useCallback(() => {
        const listOrders = [
            {
                value: -1, //Value 0 is selectId Price Asc
                text: t.getTraduction('OrderBy'),
            },
            ...(filters?.Orders || []),
        ];

        const selectOrderOptions = {
            id: 'orderVehicles',
            name: 'orderVehicles',
            text: t.getTraduction('OrderBy'),
            className: '',
            disabled: listOrders.length <= 1,
            values: listOrders,
            showLabel: false,
        };

        return (
            <div className="o-layout__item u-3/12 u-1/2@m u-float-right">
                <Select
                    value={`${filters.filterOrder.SelectId}`}
                    onChange={changeOrderVehicleList}
                    options={selectOrderOptions}
                />
            </div>
        );
    }, [
        changeOrderVehicleList,
        filters?.Orders,
        filters.filterOrder.SelectId,
        t,
    ]);

    return (
        <div className="o-layout u-mv">
            <div
                id="TagFiltersList"
                className={`o-layout__item u-${
                    extraContent ? '6' : '8'
                }/12 u-1/1@m`}
            >
                <ul className="c-tag-list">
                    <TagFilters
                        /*refreshFilters={refreshFilters}*/
                        filters={filters}
                        filtersOptions={filtersOptions}
                        resetFilters={resetFilters}
                    />
                </ul>
            </div>
            {isMobileOrTablet && renderFilters()}
            {extraContent && extraContent()}
            {orderFilters && printOrderFilter()}
        </div>
    );
};

export default HeaderPageFilters;
